import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  MenuItem,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { Admin_Parivartan_Create_Roles } from "../../../../constants";
import axios from "axios";
import toast from "react-hot-toast";

const AddNewRoleModal = ({ open, onClose, onRefresh }) => {
  const [form, setForm] = useState({ RoleId: "", RoleName: "" });

  const handleChange = (field, value) => {
    setForm((prev) => ({ ...prev, [field]: value }));
  };

  const handleReset = () => {
    setForm({ RoleId: "", RoleName: "" });
  };

  const handleSubmit = async () => {
    const payload = {
        RoleId: form.RoleId,
        RoleName: form.RoleName,
      };
  
      try {
        const res = await axios.post(Admin_Parivartan_Create_Roles, payload);
        if (res.data.success) {
          toast.success("Role Created Successfully.");
          onClose();
          onRefresh();
          handleReset();
        } else{
          toast.error(res.data.message || 'Failed to create role');
        }
      } catch (err) {
        const message =
          err?.response?.data?.message || err?.message || 'Something went wrong';
        toast.error(message);
      }
  };


  return (
    <>
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <DialogTitle>
          <Typography variant="h6" fontWeight="bold">
            Add New Role
          </Typography>
        </DialogTitle>
        <DialogContent>
          <Stack spacing={2} mt={1}>
            <TextField
              labelId="role-label"
              label="Role ID"
              value={form.RoleId}
              onChange={(e) => handleChange("RoleId", e.target.value)}
              size="small"
            />
            <TextField
              labelId="role-label"
              label="Role Name"
              value={form.RoleName}
              onChange={(e) => handleChange("RoleName", e.target.value)}
              size="small"
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            onClick={() => {
              onClose();
            }}
          >
            Cancel
          </Button>
          <Button variant="contained" onClick={handleSubmit}>
            Add
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AddNewRoleModal;
